export const GCLID_COOKIE_NAME = 'mm_gclid_session';
